import gsap, { Power2, Power4 } from 'gsap';
import { GetBy } from '../_app/cuchillo/core/Element';

export default class LogoAnim {
  constructor(__dom) {
    this._items = [...GetBy.selector("path", __dom)];
    this.end();
  }

  show(__call) {
    gsap.killTweensOf(this._items);
    gsap.to(this._items[0], {opacity:1, duration:.6, delay:.0, ease:Power2.easeIn});
    gsap.to(this._items[1], {opacity:1, duration:.7, delay:.1, ease:Power2.easeIn});
    gsap.to(this._items[2], {opacity:1, duration:.8, delay:.2, ease:Power2.easeIn});
    gsap.to(this._items[3], {opacity:1, duration:.9, delay:.3, ease:Power2.easeIn, onComplete:()=> {
      __call?.();
    }});
  }

  showhide(__call) {
    gsap.killTweensOf(this._items);
    gsap.to(this._items[0], {opacity:1, duration:.6, delay:.0, ease:Power2.easeIn});
    gsap.to(this._items[1], {opacity:1, duration:.7, delay:.1, ease:Power2.easeIn});
    gsap.to(this._items[2], {opacity:1, duration:.8, delay:.2, ease:Power2.easeIn});
    gsap.to(this._items[3], {opacity:1, duration:.9, delay:.3, ease:Power2.easeIn});

    gsap.to(this._items[0], {opacity:0, duration:.6, delay:.9, ease:Power2.easeIn});
    gsap.to(this._items[1], {opacity:0, duration:.6, delay:1.1, ease:Power2.easeIn});
    gsap.to(this._items[2], {opacity:0, duration:.6, delay:1.2, ease:Power2.easeIn});
    gsap.to(this._items[3], {opacity:0, duration:.6, delay:1.3, ease:Power2.easeIn});
  }

  hide(__call) {
    gsap.killTweensOf(this._items);
    gsap.to(this._items[0], {opacity:0, duration:.4, delay:.0, ease:Power2.easeIn});
    gsap.to(this._items[1], {opacity:0, duration:.4, delay:.1, ease:Power2.easeIn});
    gsap.to(this._items[2], {opacity:0, duration:.4, delay:.2, ease:Power2.easeIn});
    gsap.to(this._items[3], {opacity:0, duration:.4, delay:.3, ease:Power2.easeIn, onComplete:()=> {
      __call?.();
    }});
  }

  end() {
    gsap.killTweensOf(this._items);
    gsap.set(this._items[0], {y:"+0%",opacity:0});
    gsap.set(this._items[1], {x:"-0%",opacity:0});
    gsap.set(this._items[2], {y:"-0%",opacity:0});
    gsap.set(this._items[3], {x:"+0%",opacity:0});
  }
}